<template lang="pug">
div
  .card
    .container-fluid
      .row
        .col-md-12
          .white-box
            h1.box-title.m-b-0 固定ページ
            p.text-muted.m-b-30.font-13 SWAN Proサイトの固定ページ編集画面
            h3.box-title 固定ページ一覧
            StaticList(apiname='static',editPath='edit')
            router-link(to='edit')
              el-button.col-md-12(type='primary', icon='el-icon-edit') 新規登録
</template>

<script>
import StaticList from '@/views/components/swan/common/List'

export default {
  name: 'Top',
  data () {
    return {
    }
  },
  components: {
    StaticList
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/static/list.vue